import { useTranslation } from '@mukil/i18n';
import { Button } from '@jumpstone/ui-react';
import { WAGEPRO_LOCALES } from '../../lib/i18n';
import type { WageProLocale } from '../../lib/i18n';

/**
 * Locale switcher. Labels are the endonym for each language, which is
 * deliberately the same string in every locale — a Sinhala speaker looks for
 * "සිංහල", not for the English word "Sinhala".
 *
 * `setLocale` is the provider's single entry point for a locale change: it
 * calls the host's `onLocaleChange`, which swaps the bundle. Calling that
 * callback here as well would load the bundle twice per click.
 */
const LOCALE_LABELS: Record<WageProLocale, string> = {
  'en-001': 'EN',
  'si-LK': 'සිං',
  'ta-LK': 'தமி',
};

const LOCALE_NAME_KEYS: Record<WageProLocale, string> = {
  'en-001': 'locale.english',
  'si-LK': 'locale.sinhala',
  'ta-LK': 'locale.tamil',
};

export function LocaleSwitcher(): React.JSX.Element {
  const { t, locale, setLocale } = useTranslation('wp');

  return (
    <div
      className="flex items-center gap-1"
      role="group"
      aria-label={t('locale.switcher')}
    >
      {WAGEPRO_LOCALES.map((candidate) => (
        <Button
          key={candidate}
          size="xs"
          variant={locale === candidate ? 'primary' : 'ghost'}
          aria-pressed={locale === candidate}
          aria-label={t(LOCALE_NAME_KEYS[candidate])}
          onClick={() => {
            setLocale(candidate);
          }}
        >
          {LOCALE_LABELS[candidate]}
        </Button>
      ))}
    </div>
  );
}
